// A collection of shims for old browsers and environments

if (typeof URL.canParse !== 'function') {
    // Safari <17, Chrome <120, Firefox <115
    URL.canParse = function (url) {
        // Validate length
        const length = arguments.length;
        // Check if length is zero
        if (length === 0) {
            throw new TypeError('Failed to execute \'canParse\' on \'URL\': 1 argument required, but only 0 present.');
        }

        // Get base URL depending on length
        const urlString = String(url);
        const baseUrl = length < 2 || arguments[1] === undefined ? undefined : String(arguments[1]);
        try {
            return !!new URL(urlString, baseUrl);
        } catch (e) {
            return false;
        }
    }
}
